import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Heading, Text } from "components/styled";
import LineChart from "../../visualization/lineChart/lineChart";
import { dashboardLocalization, helpTextLocalization } from "localization";
import { number } from "localization";
import styled from "styled-components";
import { images } from "../../../config/index";
import NoData from "../noData";

class ProjectTimelinessChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lineChartData: [],
      parentWidth: 0,
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.fitParentContainer();
    window.addEventListener("resize", this.fitParentContainer);
  }

  getFYData(stats, year, ward) {
    const initialFY = Array.from({ length: 12 }, (x, i) => ({
      year: i + 4 > 12 ? i - 8 : i + 4,
      count: 0,
    }));

    if (!stats) {
      return initialFY;
    }

    return initialFY.map((data) => {
      const selectedFYData = stats;
      if (selectedFYData) {
        const monthData = selectedFYData[("0" + data.year).slice(-2)];
        let countObj = 0;
        if (ward && ward !== "all" && monthData) {
          countObj = monthData.ward_wise[ward] ? monthData.ward_wise[ward] : {};
        } else if (monthData) {
          countObj = monthData.overall ? monthData.overall : {};
        }
        return {
          year: data.year,
          count: countObj.total ? countObj.total.count : 0,
        };
      }
      return data;
    });
  }

  formatData(data) {
    const { selectedWard } = this.props;
    const selectedFY = "2074/75";

    return this.getFYData(data.month_wise, selectedFY, selectedWard);
  }

  getFragment(selectedWard, selectedLanguage) {
    if (selectedWard === "all") return null;

    if (selectedLanguage === "en") {
      return (
        <Fragment>
          for <strong>Ward {number(selectedWard)}</strong>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <strong>वडा {number(selectedWard)}</strong> का लागि
      </Fragment>
    );
  }

  fitParentContainer = () => {
    const { parentWidth } = this.state;

    if (!this.ref.current) return;
    
    const currentParentWidth =
      this.ref.current && this.ref.current.getBoundingClientRect().width;

    const shouldResize = parentWidth !== currentParentWidth;
    if (shouldResize) {
      this.setState({
        parentWidth: currentParentWidth,
      });
    }
  };

  render() {
    const { selectedWard, selectedLanguage, data, projectType } = this.props;
    const { lineChartTitle } = dashboardLocalization[selectedLanguage];
    const { lineChart: lineChartHelpText } =
      helpTextLocalization[selectedLanguage];
    const lineChartData = this.formatData(data);

    let noData = true;
    lineChartData.forEach(t => {
        if (t.count) {noData = false}
    })
    

    return (
      <div className="w-full">
        <ChartsBlock>
          <Heading.h2 uppercase className="chart-label flex items-center">
            <Text.span className="help-text">
              <Text.span className="help-text__icon">
                <img
                  className="help-icon"
                  height={18}
                  width={18}
                  src={images.icons.help}
                  alt="help"
                />
              </Text.span>
              <Text.span className="help-text__content tooltip">
                <Text.span className="tooltip-arrow">arrow</Text.span>
                {lineChartHelpText}
              </Text.span>
            </Text.span>
            <Text.span>
              {selectedLanguage === "en" && `${lineChartTitle} `}
              {this.getFragment(selectedWard, selectedLanguage)}
              {selectedLanguage === "np" && ` ${lineChartTitle}`}
            </Text.span>
          </Heading.h2>
        </ChartsBlock>

        <ChartsBlock lang={selectedLanguage} className="flex flex-col flex-1">
         <div
            ref={this.ref}
            className="lineChart chart card--chart relative flex flex-1 justify-center items-center"
          >
            <div id="tooltip-line" />
            <div className="line-chart">
            {noData ? <NoData selectedLanguage={selectedLanguage} /> :  <LineChart
                projectType={projectType}
                parentWidth={this.state.parentWidth}
                data={lineChartData}
              /> }
             
            </div>
          </div>
        </ChartsBlock>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.projectsStatsReducers.data.data,
  selectedWard: state.projectsStatsReducers.selectedWard,
  selectedLanguage: state.localizationReducers.selectedLanguage,
});

const ChartsBlock = styled.div`
  h2 {
    > span:last-child {
      font-size: ${(props) => (props.lang === "en" ? "12px" : "14px")};
      opacity: 0.7;
    }
  }
`;

export default connect(mapStateToProps)(ProjectTimelinessChart);



// WEBPACK FOOTER //
// ./src/components/layouts/projectLineChart/projectLineChart.js